export const TRIGGER_ALERT = "TRIGGER_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const LOADING = "LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const SET_NAV_HEIGHT = "SET_NAV_HEIGHT";
export const APP_UPDATED = "APP_UPDATED";
export const LOADING_MEDIA="LOADING_MEDIA"

